// extracted by mini-css-extract-plugin
export default {"title":"ConferenceAddVisitorComponent_title__AuYca","iconEdit":"ConferenceAddVisitorComponent_iconEdit__GH8Pw","iconEdit2":"ConferenceAddVisitorComponent_iconEdit2__M2mVe"};